<template>
    <div class="about">
        <van-nav-bar
            title="关于我们"
            left-arrow
            @click-left="onClickLeft"
        />
       <div class="about-box">
            <div class="about-logo">
                <div class="about-logo-img">
                    <img src="../../../assets/images/account/logo1.png" alt="">
                </div>
            </div>
            <div class="about-content">
                <p>
                   伟东云教育，创立于2012年，以全球互联网教育平台服务商为定位，面向各国政府、企业、院校、机构提供优质教育资源与服务，通过搭建开放型互联网教育云平台，打造“一体两翼”的全球化教育格局，努力构建惠及世界的终身教育生态。
                </p>
                <p>作为联合国教科文组织战略合作伙伴，伟东云教育先后承办两届四次国际教育信息化大会；作为上海合作组织战略合作伙伴，伟东云教育以务实合作落实“上海精神”，助推区域教育协同发展；作为中国教育部合作伙伴，伟东云教育努力践行“一带一路”教育行动，促进全球教育资源共建共享。</p>
                <p>目前，伟东云教育正以职业教育为主，积极赋能新时代职业教育发展，业务已累计覆盖全国25个省、169个市区县，在全球25个国家及地区实现布局，服务众多世界500强企业。</p>
            </div>
            <div class="copyright">
                <p>伟东集团有限责任公司 @ 版权所有 鲁ICP备13011921号</p>
            </div>
       </div>
    </div>
</template>
<script>
export default {
    name: "about",
    methods:{
        onClickLeft() {
            this.$router.go(-1);
        },
    }
}
</script>

<style lang="stylus" scoped>
    .about{
        min-height:100vh;
        box-sizing:border-box;
        position:relative;
        .about-box{
            height:100%;
            padding:0 30px ;
            box-sizing:border-box;
            padding-bottom:180px;
        }
        .about-logo{
            text-align :center;
            .about-logo-img{
                margin-top 120px
                img{
                    width:320px;
                }
            }
            p{
                color:#333;
                font-size:34px;
                margin-top:30px;
            }
        }
        .about-content{
            margin-top:40px;
            color:#666;
            line-height :56px;
            font-size:28px;
            p {
                text-indent 2em
            }
        }
        .copyright{
            position:absolute;
            bottom:40px;
            left:50%;
            transform :translateX(-50%);
            p{
                font-size :24px;
                color:#999;
                white-space: nowrap;
            }
        }
    }
</style>